var PageCollection = require('./pages.js'),
    ThumbNail = require('./thumbnail.js'),
    fvChannel = require('glRadio').channel('FV');



module.exports = PageCollection.extend({

    model: ThumbNail,

    initialize: function() {

        // This will match the height of the Thumb Scroller Div
        // I think this was only put in for debugging purposes -- can remove
        this.totalThumbScrollHeight = 0;

    },

    /**
     * Thumbs unaffected by scale, don't need to be recalculated.
     * The bottom position of the current thumb from the top of the container
     */
    setVOffsets: function() {

        var vPADDING = fvChannel.request('cssConstants').V_PADDING,
            totalThumbsHeight = 0;

        this.each( function(thumb) {

            var curOffset =  (2 * vPADDING) + thumb.getRotatedHeight();
            totalThumbsHeight += curOffset;
            thumb.set({'vOffset':  totalThumbsHeight});

        });

        this.totalThumbScrollHeight = totalThumbsHeight;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/models/page/thumbnails.js
 ** module id = 399
 ** module chunks = 0
 **/